import React from 'react';
import { useLocation } from 'react-router-dom';
import { useIonRouter } from '@ionic/react';
import { PushNotificationsService } from '../api/PushNotificationsService';
import { userStore } from '../api/AuthService';
import { HomeNavIcon, TripNavIcon } from '../components/icons';
import { HandbookSvg, LoadSvg, MoneySvg } from '../components/svgIcons';

type NavItem = {
  label: string;
  to: string;
  paths: string[];
  idSuffix: string;
  Icon: React.FC<{ color?: string; size?: number }>;
  onClick?: () => void;
};

const navItems: NavItem[] = [
  {
    label: 'Home',
    to: '/Home',
    paths: ['/home'],
    idSuffix: 'navHomeMain',
    Icon: HomeNavIcon,
    onClick: () => {
      const userId = userStore.getState().user?.id;
      if (userId) {
        PushNotificationsService.registerAfterAppLogin(userId);
      }
    },
  },
  {
    label: 'Load',
    to: '/Load',
    paths: ['/load'],
    idSuffix: 'navLoadMain',
    Icon: LoadSvg,
  },
  {
    label: 'Trip',
    to: '/Trip',
    paths: ['/trip'],
    idSuffix: 'navTripMain',
    Icon: TripNavIcon,
  },
  {
    label: 'Pay',
    to: '/Money',
    paths: ['/money'],
    idSuffix: 'navMoneyMain',
    Icon: MoneySvg,
  },
  {
    label: 'Docs',
    to: '/Docs',
    paths: ['/docs', '/claims'],
    idSuffix: 'navDocsMain',
    Icon: HandbookSvg,
  },
];

const Nav = (props: { pageName?: string; onSearch?: (target: boolean) => void }) => {
  const location = useLocation();
  const ionRouter = useIonRouter();
  const pathname = location.pathname.replace(/\/+$/, '').toLowerCase() || '/';
  const pageName = props.pageName || '';
  const accent = 'var(--home-accent)';
  const inactive = 'var(--home-nav-inactive)';

  return (
    <div className="nav-design-a" id="navi">
      <nav className="nav-items" aria-label="Main">
        {navItems.map(item => {
          const active = item.paths.includes(pathname);
          const color = active ? accent : inactive;
          const id = `${pageName}${item.idSuffix}`;
          const { Icon } = item;

          return (
            <a
              key={item.to}
              href={item.to}
              className={`nav-item${active ? ' nav-item--active' : ''}`}
              style={{ textDecoration: 'none' }}
              id={id}
              onClick={e => {
                e.preventDefault();
                item.onClick?.();
                ionRouter.push(item.to, 'root', 'push');
              }}
            >
              <div id={id} className="nav-item__inner">
                <span id={id} className="nav-item__icon" aria-hidden="true">
                  <Icon color={color} size={24} />
                </span>
                <p id={id} className="nav-item__label" style={{ color }}>
                  {item.label}
                </p>
              </div>
            </a>
          );
        })}
      </nav>
    </div>
  );
};

export default Nav;
